import { useTranslation } from "react-i18next";
import type { TmTaskStatus } from "../../api/tm";

const STYLES: Record<TmTaskStatus, { bg: string; fg: string }> = {
  TODO:        { bg: "var(--surface-muted)", fg: "var(--ink-2)" },
  IN_PROGRESS: { bg: "var(--info-bg)", fg: "var(--info)" },
  IN_REVIEW:   { bg: "var(--warn-bg)", fg: "var(--warn)" },
  DONE:        { bg: "var(--ok-bg)", fg: "var(--ok)" },
  BLOCKED:     { bg: "var(--err-bg)", fg: "var(--err)" },
  CANCELLED:   { bg: "var(--surface-muted)", fg: "var(--ink-3)" },
};

export function TmStatusBadge({ status }: { status: TmTaskStatus }) {
  const { t } = useTranslation();
  // A state the browser does not know is a state the server added since this bundle was built,
  // which is exactly what a reader with an open tab sees during a release. An unknown state is
  // shown plainly rather than taking the screen down with it.
  const s = STYLES[status] ?? { bg: "var(--surface-2)", fg: "var(--ink-2)" };
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      padding: "2px 10px", borderRadius: 999,
      background: s.bg, color: s.fg, fontSize: 12, fontWeight: 600,
    }}>
      <span style={{ width: 6, height: 6, borderRadius: 999, background: s.fg }} />
      {t(`tm.status.${status}`, { defaultValue: status })}
    </span>
  );
}
